import { render, staticRenderFns } from "./HyphenInput.vue?vue&type=template&id=25184262&scoped=true"
import script from "./HyphenInput.vue?vue&type=script&setup=true&lang=js"
export * from "./HyphenInput.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HyphenInput.vue?vue&type=style&index=0&id=25184262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25184262",
  null
  
)

export default component.exports